import React, { ChangeEvent, FC, useEffect } from 'react'
import { Promotion } from '../../@types/prefix'
import { Button, Checkbox, Flex, Form, Input, Select, Space } from 'antd'
// import { RedoOutlined } from '@ant-design/icons';
// import { getDomainWithoutSubdomain } from '../../utils/domainWithoutSubdomain'
import { useLocation } from 'react-router-dom';
import Turnstile from "react-turnstile";
import PatternNumber from '../../helpers/PatternNumber';

interface RegisterStep3Props {
	knowFrom: string
	defaultAffiliateCode: string
	promotions: Promotion[]
	isSubmitting: boolean
	recaptcha: any
	resetCounter: number

	setKnowFrom: (e: any) => void
	handleSubmit: (e: ChangeEvent<any>) => void
	setTurnstile: (e: any) => void
	termandcondition: string
	termandconditionModal: (e: ChangeEvent<any>) => void
	setCheckTermandcondition: (e: any) => void
}

const RegisterStep3: FC<RegisterStep3Props> = ({
	knowFrom,
	defaultAffiliateCode,
	promotions,
	isSubmitting,
	recaptcha,
	resetCounter,

	setKnowFrom,
	handleSubmit,
	setTurnstile,
	termandcondition,
	termandconditionModal,
	setCheckTermandcondition
}) => {
	const affiliateReadOnly = defaultAffiliateCode ? true : false

	const location = useLocation();
	const params = new URLSearchParams(location.search);
	const getParamsRec = params.get('rec');

	return (
		<>
			<Form.Item
				name="password"
				label="รหัสผ่าน (ตัวเลข 6 หลัก)"
				rules={[
					{ required: true, message: 'กรุณากรอกรหัสผ่าน' },
					{ pattern: PatternNumber, message: 'กรุณากรอกเป็นตัวเลขเท่านั้น' }
				]}
				style={{ marginBottom: 16 }}
				hasFeedback>
				<Input.Password placeholder="รหัสผ่าน (ตัวเลข 6 หลัก)" inputMode='numeric' maxLength={6} minLength={6} showCount />
			</Form.Item>
			<Form.Item
				name="line"
				label="ไอดีไลน์"
				rules={[{ required: true, message: 'กรุณากรอกไอดีไลน์' }]}
				style={{ marginBottom: 16 }}
				hasFeedback>
				<Input placeholder="ไอดีไลน์" inputMode='text' />
			</Form.Item>
			<Form.Item
				name="autoBonus"
				label="รับโบนัสอัตโนมัติ"
				rules={[{ required: true, message: 'กรุณาเลือกรับโบนัสอัตโนมัติ' }]}
				style={{ marginBottom: 16 }}
				hasFeedback
				initialValue={"off"}>
				<Select
					placeholder="เลือกรับโบนัสอัตโนมัติ"
					showSearch
					optionFilterProp="children"
					filterOption={(input: any, option: any) =>
						option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
					}>
					<Select.Option value="off">ไม่รับโบนัสอัตโนมัติ</Select.Option>
					{promotions
						.filter((v) => v.amount > 0)
						.map((promotion) => (
							<Select.Option value={promotion.key} key={promotion.key}>
								{promotion.name}
							</Select.Option>
						))}
				</Select>
			</Form.Item>
			{!defaultAffiliateCode && (
				<Form.Item
					name="knowFrom"
					label="ช่องทางที่รู้จักเรา"
					rules={[{ required: true, message: 'กรุณาเลือกช่องทางที่รู้จักเรา' }]}
					style={{ marginBottom: 16 }}
					initialValue={getParamsRec}
					hasFeedback>
					<Select
						placeholder="เลือกช่องทางที่รู้จักเรา ..."
						showSearch
						disabled={getParamsRec ? true : false}
						optionFilterProp="children"
						onSelect={setKnowFrom}
						filterOption={(input: any, option: any) =>
							option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
						}>
						<Select.Option value="facebook" key="facebook">Facebook</Select.Option>
						<Select.Option value="twitter" key="twitter">Twitter</Select.Option>
						<Select.Option value="line" key="line">Line</Select.Option>
						<Select.Option value="google" key="google">Google</Select.Option>
						<Select.Option value="sms" key="sms">SMS</Select.Option>
						<Select.Option value="instargram" key="instargram">Instargram</Select.Option>
						<Select.Option value="youtube" key="youtube">Youtube</Select.Option>
						<Select.Option value="tiktok" key="tiktok">Tiktok</Select.Option>
						<Select.Option value="onlyfans" key="onlyfans">Onlyfans</Select.Option>
						<Select.Option value="telegram" key="telegram">Telegram</Select.Option>
						<Select.Option value="vk" key="vk">VK</Select.Option>
						<Select.Option value="friend" key="friend">เพื่อนแนะนำ</Select.Option>
						<Select.Option value="other" key="other">โฆษณาอื่น ๆ</Select.Option>
					</Select>
				</Form.Item>
			)}
			{defaultAffiliateCode && (
				<Form.Item
					name="knowFrom2"
					label="ช่องทางที่รู้จักเรา"
					rules={[{ required: true, message: 'กรุณาเลือกช่องทางที่รู้จักเรา' }]}
					initialValue={getParamsRec}
					style={{ marginBottom: 16 }}
					hasFeedback>
					<Select
						placeholder="เลือกช่องทางที่รู้จักเรา ..."
						showSearch
						disabled={getParamsRec ? true : false}
						optionFilterProp="children"
						filterOption={(input: any, option: any) =>
							option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
						}
					>
						<Select.Option value="facebook" key="facebook">Facebook</Select.Option>
						<Select.Option value="twitter" key="twitter">Twitter</Select.Option>
						<Select.Option value="line" key="line">Line</Select.Option>
						<Select.Option value="google" key="google">Google</Select.Option>
						<Select.Option value="sms" key="sms">SMS</Select.Option>
						<Select.Option value="instargram" key="instargram">Instargram</Select.Option>
						<Select.Option value="youtube" key="youtube">Youtube</Select.Option>
						<Select.Option value="tiktok" key="tiktok">Tiktok</Select.Option>
						<Select.Option value="onlyfans" key="onlyfans">Onlyfans</Select.Option>
						<Select.Option value="telegram" key="telegram">Telegram</Select.Option>
						<Select.Option value="vk" key="vk">VK</Select.Option>
						<Select.Option value="other" key="other">โฆษณาอื่น ๆ</Select.Option>
					</Select>
				</Form.Item>
			)}

			{knowFrom === "friend" && (
				<Form.Item
					name="affiliateCode"
					label="รหัสชวนเพื่อน"
					rules={[{ required: true, message: 'กรุณากรอกรหัสชวนเพื่อน' }]}
					style={{ marginBottom: 16 }}
					hasFeedback
					initialValue={defaultAffiliateCode}>
					<Input placeholder="รหัสชวนเพื่อน" inputMode='text' readOnly={affiliateReadOnly} />
				</Form.Item>
			)}

			{recaptcha.enable && (
				<div style={{ marginBottom: "10px" }}>
					<Turnstile
						key={resetCounter}
						sitekey={recaptcha.key}
						theme="dark"
						onVerify={(token) => setTurnstile(token)}
						retry='auto'
						autoResetOnExpire={true}
					/>
				</div>
			)}

			{termandcondition && (
				<div className="termandcondition-form-item">
					<Checkbox onChange={setCheckTermandcondition}>
						ยอมรับ<span className="termandcondition" onClick={termandconditionModal}>เงื่อนไขและข้อตกลง</span>
					</Checkbox>
				</div>
			)}

			<Form.Item style={{ marginBottom: 0 }}>
				<Button
					type="primary"
					htmlType="submit"
					loading={isSubmitting}
					onClick={handleSubmit}
					block
				>
					สมัครสมาชิก
				</Button>
			</Form.Item>
		</>
	)
}

export default RegisterStep3
